import React from 'react'
import { Row, Col, Form, Button, Card } from 'react-bootstrap'
import { SubHeader, RadioList, CheckboxListNoLabel } from '../../../components/'
import InputWithBadge from '../../../components/InputWithBadge'
import ShadowAccountProfile from '../shadowAccountProfile/ShadowAccountProfile'

import './integrationProfile.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

const IntegrationProfile = (props) => {

  const { action } = props;

  const isCheckCustRef = { text: "Check Customer Reference", name: "isCheckCustRef", disabled: true };
  const emailNoti = { text: "Email Notification", name: "emailNoti", disabled: true };
  const statementDisplayOption = { text: "Statement Display Option", name: "statementDisplayOption", disabled: action === "view", list: [{ label: "Show Detail", value: "detail" }, { label: "Summary", value: "summary", disabled: props.type === "REDIRECT" }, { label: "Summary by Detail", value: "sumByDet", disabled: props.type === "REDIRECT" }, { label: "Master AC by details", value: "mAcctByDet", disabled: props.type === "REDIRECT" }] };
  const encryptResMsg = { text: "Encrypt Response Message", name: "encryptResMsg", disabled: true };
  const type = { text: "Merchant Integration Type", name: "type", disabled: true, list: [{ label: "Redirect", value: "REDIRECT" }, { label: "API", value: "API" }] };

  const onChange = (name, value, format) => {
    props.onChange(name, value, format)
  }

  const categoryOptions = <option key={props["merchantCategory"]} value={props["merchantCategory"]}>{props["merchantCategoryName"]}</option>;

  const retailCustomer = [
    { name: "easyApp", label: "Easy App" },
    { name: "easyNet", label: "Easy Net" },
  ];

  const corporateCustomer = [
    { name: "businessNet", label: "Business Net" },
    { name: "businessAnywhere", label: "Business Anywhere" }
  ];

  const paymentGateway = [
    { name: "ePayment", label: "e-Payment" },
  ];
  return (
    <>
      <SubHeader text="Merchant Integration Profile" />
      {action !== "create" &&
        <Row className="mt-3">
          <Col sm={6}>
            <InputWithBadge text="Merchant ID" placeholder="Merchant ID" name="merchantId" disabled onChange={onChange} status={props["status"]} value={props["merchantId"]} />
          </Col>
        </Row>
      }
      <Row className="mt-3">
        <Col>
          <Form.Label className="text-grey font-weight-bold medium required">{"Merchant Category"}</Form.Label>
          <Form.Control
            as="select"
            name="merchantCategory"
            onChange={(e) => onChange(e.target.name, e.target.value)}
            value={props["merchantCategory"]}
            disabled={true}
            required>
            <option value="" hidden>Select</option>
            {categoryOptions}
          </Form.Control>
        </Col>
        <Col>
          <Form.Label className="text-grey font-weight-bold medium">Certificate</Form.Label>
          <Row className="px-3">
            <Col className="custom-file">
              <Form.Label className="custom-file-label">{props["certificateFileName"] !== "" ? props["certificateFileName"] : "Choose file to upload"}</Form.Label>
              <Form.Control
                id="certificate"
                className="custom-file-input"
                type="file"
                name="certificate"
                disabled={true}
                value=""
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Row className="mb-4">
            <Col>
              <RadioList
                text={isCheckCustRef.text}
                name={isCheckCustRef.name}
                value={props[isCheckCustRef.name]}
                disabled={true}
                list={isCheckCustRef.list}
                required
                className="mt-1" />
            </Col>
            <Col>
              <RadioList
                text={emailNoti.text}
                name={emailNoti.name}
                value={props[emailNoti.name]}
                disabled={true}
                list={emailNoti.list}
                required
                className="mt-1" />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
              <RadioList
                text={type.text}
                name={type.name}
                value={props[type.name]}
                disabled={type.disabled}
                list={type.list}
                required
                className="mt-1" />
            </Col>
            <Col>
              <RadioList
                text={encryptResMsg.text}
                name={encryptResMsg.name}
                value={props[encryptResMsg.name]}
                disabled={true}
                list={encryptResMsg.list}
                required
                className="mt-1" />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>
              <RadioList
                text={statementDisplayOption.text}
                name={statementDisplayOption.name}
                value={props[statementDisplayOption.name]}
                disabled={true}
                list={statementDisplayOption.list}
                required
                className="mt-1" />
            </Col>
          </Row>
          {(props.type === "API" && props.statementDisplayOption === "mAcctByDet") &&
            <Row>
              <Col sm={10}>
                <Card className="rounded p-3 bg-light">
                  <Row className="mb-1">
                    <Col>
                       <Row className="pl-4">
                        <Col>
                          <ShadowAccountProfile
                            shadowAccountProfile={props.shadowAccountProfile}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          }
          {props.type === "REDIRECT" &&
            <Row>
              <Col sm={9}>
                <Card className="rounded p-3 bg-light">
                  <Row className="mb-1">
                    <Col>
                      <Form.Label className="text-grey font-weight-bold medium required">{"Redirect Payment Option"}</Form.Label>
                      <Row className="pl-4">
                        <Col>
                          <Form.Check
                            custom inline
                            className="text-grey medium font-weight-bold mt-2"
                            type={"checkbox"}
                            id="retailCustomer"
                            label="Retail Customer"
                            checked={props.retailCustomer}
                            required={!(props.retailCustomer || props.corporateCustomer || props.paymentGateway)}
                            disabled={true}
                          />
                          <CheckboxListNoLabel text="retailCustomer"
                            disabled={true}
                            {...props}
                            list={retailCustomer}
                            required={!(props.easyNet || props.easyApp)}
                            style={{ fontSize: "1.125rem" }} />
                        </Col>
                      </Row>
                      <Row className="pl-4">
                        <Col>
                          <Form.Check
                            custom inline
                            className="text-grey medium font-weight-bold mt-2"
                            type={"checkbox"}
                            id="corporateCustomer"
                            label="Corporate Customer"
                            checked={props.corporateCustomer}
                            required={!(props.retailCustomer || props.corporateCustomer || props.paymentGateway)}
                            disabled={true}
                          />
                          <CheckboxListNoLabel name="corporateCustomer"
                            disabled={true}
                            {...props}
                            list={corporateCustomer}
                            className="mt-1"
                            required={!(props.businessNet || props.businessAnywhere || props.corporatePortal)}
                            style={{ fontSize: "1.125rem" }} />
                        </Col>
                      </Row>
                      <Row className="pl-4">
                        <Col>
                          <Form.Check
                            custom inline
                            className="text-grey medium font-weight-bold mt-2"
                            type={"checkbox"}
                            id="paymentGateway"
                            label="Payment Gateway"
                            checked={props.paymentGateway}
                            required={!(props.retailCustomer || props.corporateCustomer || props.paymentGateway)}
                            disabled={true}
                          />
                          <CheckboxListNoLabel name="paymentGateway"
                            disabled={true}
                            {...props}
                            list={paymentGateway}
                            required={!(props.ePayment)}
                            style={{ fontSize: "1.125rem" }} />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pl-4">
                    <Col>
                      <RadioList
                        text={"Allow Schedule Payment"}
                        name={"allowSchedulePayment"}
                        disabled={true}
                        value={props.allowSchedulePayment}
                        required />
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          }
        </Col>
      </Row>
    </>
  )
}

export default IntegrationProfile
